








































































































import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { NormsServices } from '../api/NormsServices';
import Loading from 'vue-loading-overlay';
import multiselect from 'vue-multiselect';
import ConfirmationDialog from '../../core/components/ConfirmationDialog.vue';
import Input from '../../core/components/Input.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import { EventBus, hasElements, TypeEventBus, sortObjectByPropertyName, getIndexFromList, itemsPerPageOptionsTable } from '../../core/utils';
import Sortable from 'sortablejs';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import { config } from 'rxjs';

@Component({
    components: {
        Loading,
        Input,
        SimpleTable
    }
})
export default class CreateClasification extends Mixins(
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
) {
    @Prop() items;
    @Prop() disabled;
    @Prop() visible;
    itemsTable: any = [];
    formStatus: object = {
        end: null,
        icon: 'mdi-alert'
    };
    itemsPerPage: any = itemsPerPageOptionsTable;
    fav: boolean = true;
    menu: boolean = false;
    message: boolean = false;
    pendingRequest: boolean = false;
    hints: boolean = true;
    loadingText: string = '';
    modalTitle: string = 'Crear nueva clasificación';
    description: string = '';
    headers: any = [
        {
            text: '',
            align: 'center',
            sortable: false,
            value: 'handle',
            class: 'short-column'
        },
        {
            text: 'Ecu',
            align: 'center',
            value: 'solicited.ecu.description'
        },
        {
            text: 'Frame',
            align: 'center',
            value: 'solicited.frame.description'
        },
        {
            text: 'Parámetro',
            align: 'center',
            value: 'solicited.variable.description'
        },
        {
            text: 'Descripción',
            align: 'center',
            value: 'description'
        }
    ];

    updateDescription(value){
        this.description = value;
    }

    mounted() {
        let items = this.items;
        items = items.filter((v, i, a) => getIndexFromList(a, 'id', v['id']) === i);
        let self = this;

        this.$nextTick(() => {
            self.itemsTable = items;
            let vm = this;
            let table = this.table.$el.querySelector('tbody');
            const _self = this;
            Sortable.create(table, {
                handle: '.handle', // Use handle so user can select text
                onEnd({ newIndex, oldIndex }) {
                    const rowSelected = _self.itemsTable.splice(oldIndex, 1)[0]; // Get the selected row and remove it
                    _self.itemsTable.splice(newIndex, 0, rowSelected); // Move it to the new index
                }
            });
        });
    }

    get table(): HTMLFormElement {
        return this.$refs.tableCreateClasification as HTMLFormElement;
    }

    generateClasification() {
        let configuration = {
            description: this.description,
            calculated_parameters: this.getSelectedParameters()
        };
        this.pendingRequest = true;
        this.$set(this.formStatus, 'end', null);

        NormsServices.postCreateClasification(configuration)
            .then(response => {
                this.$set(this.formStatus, 'end', true);
                this.$set(this.formStatus, 'icon', 'mdi-checkbox-marked-circle');
                this.loadingText = 'Clasificación creada correctamente';
                this.$emit('add-new-clasification', response);
                setTimeout(() => {
                    this.pendingRequest = false;
                    this.closeDialog();
                }, 1500);
            })
            .catch(error => {
                if (error && error.response && error.response.data && error.response.data.message) {
                    this.loadingText = error.response.data.message;
                } else {
                    this.loadingText = 'Ocurrió un error';
                }
                this.$set(this.formStatus, 'end', false);
                this.$set(this.formStatus, 'icon', 'mdi-alert');
                setTimeout(() => {
                    this.pendingRequest = false;
                }, 1500);
            });
    }

    get showFormMessage() {
        if (this.formStatus['end'] !== null) {
            return true;
        } else {
            return false;
        }
    }

    getSelectedParameters() {
        let selectedParams: any = [];
        for (let i = 0; i < this.itemsTable.length; i++) {
            selectedParams.push(this.itemsTable[i]['id']);
        }

        return selectedParams;
    }

    closeDialog() {
        this.$emit('close-modal');
    }
}
